import {
  ReactComponent as ChargersActiveIcon,
  ReactComponent as ChargersIcon,
} from '../../../assets/icons/sidebar/sidebar-chargers.svg';
import { MenuItem } from '../../../interface/menuItem-interfaces';

/**
 * Roaming Menus List
 * @returns {any} Roaming menu list
 */
const RoamingMenu = (): MenuItem[] => [
  {
    id: 'roaming',
    label: 'roaming',
    url: '/ev-admin/ocpi',
    allow: true,
    svgIcon: <ChargersIcon />,
    activeSvgIcon: <ChargersActiveIcon />,
  },
];

export default RoamingMenu;
